import * as React from "react";
import { SVGProps } from "react";

const Electroneum = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2500 2491" {...props}>
    <path
      fill="#091b26"
      d="m1720.15 991.52 204 154.4 129 97.48-144.1 73.26-289.41 147.74 99.3 68.42 138.65 96.27-150.16 77.5-920.31 474.69a1036.16 1036.16 0 0 0 499.52 128.36c572.17 0 1036-463.79 1036-1036a1029.91 1029.91 0 0 0-240.37-663.6l-362.12 381.48ZM810.82 1581l-204-155-129-97.48 144.1-73.26 289.41-147.76-99.3-69-138.65-96.29 150.16-77.5 969.36-500.12a1025.57 1025.57 0 0 0-548-156.82c-572.17 0-1036 463.79-1036 1036 0 265.8 100.51 508.6 265.2 692.06L810.82 1581Z"
    />
    <path
      fill="#091b26"
      d="M395.37 1987.77c-182.85-200.41-294.26-466.82-294.26-758.66 0-621.82 506.18-1128 1128-1128 229.47 0 452.89 69.63 641.2 201l100.51-52.07C1765 93.24 1507.63 0 1229.11 0 551.59 0 0 551.59 0 1229.11 0 1550 123.52 1841.85 325.14 2061l70.23-73.26ZM2129.48 532.4c167.72 196.78 269.44 452.29 269.44 730.2 0 621.82-506.18 1128-1128 1128-210.7 0-417.17-58.73-595.18-170.14l-103.54 53.28c205.26 142.29 449.26 218 698.72 218 677.52 0 1229.11-551.59 1229.11-1229.11 0-307-113.22-588.52-300.31-804.07l-70.23 73.87Z"
    />
    <path
      fill="#23bee2"
      d="m674.93 1350.59 294.26 222.81-664.81 700.54 1321.75-681.76-238.56-165.29 440.18-225.24-294.26-222.82 664.81-699.92L876.56 960.67 1115.11 1126l-440.18 224.59Z"
    />
  </svg>
);

export default Electroneum;
